<template>
  <div
    id="avatar"
    :style="divClass"
  >
    <img
      :src="img"
    >
  </div>
</template>

<script>
export default {
    name: "Avatar",
    props: ['img', 'maxWidth'],
    data() {
        return {
            divClass: {
                maxWidth: this.maxWidth
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import './Layout.scss';
</style>